export default __webpack_public_path__ + "geomanist-ultra-webfont.7061e9.woff";